export default __webpack_public_path__ + "static/media/myfoto8.40b1b44a.jpeg";